export const getFullHeadsign = (name) => {
    if (!name) return "brak";
    switch (name) {
        case "Karwiny Nowowiczl": return "Karwiny Nowowiczlińska";
        case "Gdynia Karwiny No": return "Gdynia Karwiny Nowowiczlińska";
        case "Wiczlino Niemotow": return "Wiczlino Niemotowo";
        case "Witomino Leśniczó": return "Witomino Leśniczówka";
        case "Oksywie Godebskie": return "Oksywie Godebskiego";
        case "Baza na Pogórzu D": return "Baza na Pogórzu Dolnym";
        default: return name;
    }
};
